import Row from '@/classes/templates/Row'

export default class Rows extends Array {
  constructor (rows, ...rest) {
    Array.isArray(rows) ? super(...rows.map(row => new Row(row))) : super(...rest)
  }
}
